import React from "react";

// Gerekli ikonları import edelim
import { FaBook, FaBookOpen, FaCat, FaDog, FaPlusCircle } from "react-icons/fa";

// Stil dosyamızı import edelim
import "./ThreeColumnSection.scss";

// Görselleri import edelim
import wave from "../../assets/images/wave.png";
import cardBg from "../../assets/images/card-bg.png";

import catIcon from "../../assets/images/cat-icon.png";
import dogIcon from "../../assets/images/dog-icon.png";
import vetIcon from "../../assets/images/vet-icon.png";

// Kartların içeriğini bir dizi olarak tanımlıyoruz
const cardData = [
  {
    icon: catIcon,
    iconBg: "#45B334",
    iconColor: "#45B334",
    title: "Kediniz İçin Sağlık",
    description:
      "Kediniz için güvenilir, özenli ve uzman veterinerlik hizmetleri.",
  },
  {
    icon: dogIcon,
    iconBg: "#005E8C",
    iconColor: "#3A97DF",
    title: "Köpeğiniz İçin Sağlık",
    description:
      "Köpeğiniz için güvenilir, özenli ve uzman veterinerlik hizmetleri.",
  },
  {
    icon: <FaBookOpen />,
    iconBg: "#e09f25",
    iconColor: "#45B334",
    title: "Bilgi & Tavsiyeler",
    description: "Evcil dostlarınızın sağlığı için ipuçları ve öneriler..",
  },
];

const InfoCard = ({ icon, iconBg, iconColor, title, description }) => {
  return (
    <div className="info-card">
      <img src={cardBg} alt="card background" className="info-card__bg-image" />
      <div className="info-card__content">
        <div
          className="info-card__icon-wrapper"
          style={{ backgroundColor: iconBg, color: iconColor }}
        >
          {title === "Bilgi & Tavsiyeler" ? (
            <span style={{ color: "white" }}>{icon}</span>
          ) : (
            <img src={icon} />
          )}
        </div>
        <div className="info-card__text-wrapper">
          <h3 className="info-card__title">{title}</h3>
          <p className="info-card__description">{description}</p>
        </div>
      </div>
    </div>
  );
};

const ThreeColumnSection = () => {
  return (
    <section className="three-column-section">
      {/* Dalgalı arkaplan görselleri */}
      <div className="wavy-bg">
        <img src={wave} alt="wavy background" className="wave" />
      </div>

      {/* Kartları içeren ana konteyner */}
      <div className="cards-container">
        {cardData.map((card, index) => (
          <InfoCard
            key={index}
            icon={card.icon}
            iconBg={card.iconBg}
            iconColor={card.iconColor}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
};

export default ThreeColumnSection;
